import { defineStore } from "pinia";
import type { Size } from "@/types/resize";

interface SizeState {
  sizes: Size[]; // All available sizes
  selectedSizes: Size[]; // Sizes user has selected,
  inputFile: File | null; // The uploaded file
  inputPreview: string | null; // Preview URL for the uploaded file
  inputUrl: string; // S3 URL after upload
  deSelectedSizes: Size[]; // Sizes user has deselected
  cameFromEditWithAI: boolean;
  isResizing: boolean;
  multiSizeTemplateId: number | null;
}

export const useResizeStore = defineStore("resize", {
  state: (): SizeState => ({
    sizes: [
      {
        name: "Bottom Nav 3",
        width: 82,
        height: 30,
        category: "Custom sizes",
        placementId: "custom-82x30",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Bottom Nav (rest)",
        width: 59,
        height: 56,
        category: "Custom sizes",
        placementId: "custom-59x56",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Bottom Nav (rest LM)",
        width: 72,
        height: 56,
        category: "Custom sizes",
        placementId: "custom-72x56",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Side Sticky",
        width: 96,
        height: 35,
        category: "Custom sizes",
        placementId: "custom-96x35",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Bottompopup",
        width: 360,
        height: 135,
        category: "ECHO",
        placementId: "custom-360x135",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Bottompopup1",
        width: 360,
        height: 135,
        category: "Custom sizes",
        placementId: "custom-360x135",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Bottompopup2",
        width: 360,
        height: 67,
        category: "Custom sizes",
        placementId: "custom-360x67",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "MOA",
        width: 340,
        height: 99,
        category: "Custom sizes",
        placementId: "custom-340x99",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "MOA HT",
        width: 530,
        height: 100,
        category: "Custom sizes",
        placementId: "custom-530x100",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "MOA 2 LM",
        width: 328,
        height: 70,
        category: "Custom sizes",
        placementId: "custom-328x70",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "MOA LM",
        width: 656,
        height: 100,
        category: "Custom sizes",
        placementId: "custom-656x100",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "EOA LH",
        width: 340,
        height: 75,
        category: "Custom sizes",
        placementId: "custom-340x75",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "EOA",
        width: 640,
        height: 80,
        category: "Custom sizes",
        placementId: "custom-640x80",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "MREC",
        width: 300,
        height: 250,
        category: "Display",
        placementId: "display-300x250",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Masthead",
        width: 728,
        height: 90,
        category: "Display",
        placementId: "display-728x90",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Bottom Sticky",
        width: 320,
        height: 50,
        category: "Display",
        placementId: "display-320x50",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Skyscraper",
        width: 160,
        height: 600,
        category: "Display",
        placementId: "display-160x600",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "YouTube Channel Banner",
        width: 2560,
        height: 1440,
        category: "Social",
        placementId: "youtube-channel-banner",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "YouTube Channel Banner Desktop",
        width: 2560,
        height: 1440,
        category: "Social",
        placementId: "youtube-channel-banner-desktop",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Meta Feed Landscape",
        width: 1200,
        height: 628,
        category: "Social",
        placementId: "meta-feed-landscape",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "LinkedIn Single Image Landscape",
        width: 1200,
        height: 628,
        category: "Social",
        placementId: "linkedin-single-image-landscape",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "X Website Card",
        width: 1200,
        height: 628,
        category: "Social",
        placementId: "x-website-card",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Google Display Landscape",
        width: 1200,
        height: 628,
        category: "Social",
        placementId: "google-display-landscape",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Meta Feed Square",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "meta-feed-square",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Instagram Profile Grid 1x1",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "instagram-profile-grid-1x1",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "LinkedIn Square",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "linkedin-square",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "X Square",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "x-square",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Threads Square",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "threads-square",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Google Square",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "google-square",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "YouTube Square Video",
        width: 1080,
        height: 1080,
        category: "Social",
        placementId: "youtube-square-video",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Facebook Post",
        width: 1200,
        height: 900,
        category: "Social",
        placementId: "facebook-feed-4x3",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Facebook Cover",
        width: 820,
        height: 360,
        category: "Social",
        placementId: "facebook-page-cover",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Meta Stories Reels",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "meta-stories-reels",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "TikTok In Feed",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "tiktok-in-feed",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "YouTube Shorts",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "youtube-shorts",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Snapchat",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "snapchat",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Pinterest",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "pinterest",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "IAB Mobile Interstitial",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "iab-mobile-interstitial",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "X Vertical",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "x-vertical",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "LinkedIn Vertical Video",
        width: 1080,
        height: 1920,
        category: "Social",
        placementId: "linkedin-vertical-video",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Meta Feed 4x5",
        width: 1080,
        height: 1350,
        category: "Social",
        placementId: "meta-feed-4x5",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Instagram Profile Grid 4x5",
        width: 1080,
        height: 1350,
        category: "Social",
        placementId: "instagram-profile-grid-4x5",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "LinkedIn Vertical 4x5",
        width: 1080,
        height: 1350,
        category: "Social",
        placementId: "linkedin-vertical-4x5",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "X 4x5",
        width: 1080,
        height: 1350,
        category: "Social",
        placementId: "x-4x5",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Google Demand Gen Portrait",
        width: 1080,
        height: 1350,
        category: "Social",
        placementId: "google-demand-gen-portrait",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Threads 4x5",
        width: 1080,
        height: 1350,
        category: "Social",
        placementId: "threads-4x5",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "YouTube Horizontal Ads",
        width: 1920,
        height: 1080,
        category: "Social",
        placementId: "youtube-horizontal-ads",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Broadcast Title Safe",
        width: 1920,
        height: 1080,
        category: "Social",
        placementId: "broadcast-title-safe",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "X 16x9",
        width: 1920,
        height: 1080,
        category: "Social",
        placementId: "x-16x9",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "LinkedIn 16x9 Video",
        width: 1920,
        height: 1080,
        category: "Social",
        placementId: "linkedin-16x9-video",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Facebook Instream 16x9",
        width: 1920,
        height: 1080,
        category: "Social",
        placementId: "facebook-instream-16x9",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Billboard",
        width: 970,
        height: 250,
        category: "Social",
        placementId: "display-970x250",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Tablet - landscape",
        width: 1024,
        height: 768,
        category: "Social",
        placementId: "interstitial-1024x768",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Tablet - portrait",
        width: 768,
        height: 1024,
        category: "Social",
        placementId: "interstitial-768x1024",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Large Rectangle (Large MPU)",
        width: 336,
        height: 280,
        category: "Social",
        placementId: "display-336x280",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Large Rectangle",
        width: 336,
        height: 228,
        category: "Social",
        placementId: "display-336x228",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Half Page / Large Skyscraper",
        width: 300,
        height: 600,
        category: "Social",
        placementId: "display-300x600",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Medium Rectangle (MPU)",
        width: 300,
        height: 250,
        category: "Social",
        placementId: "display-300x250",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Mobile - landscape",
        width: 480,
        height: 320,
        category: "Social",
        placementId: "interstitial-480x320",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Mobile - portrait",
        width: 320,
        height: 480,
        category: "Social",
        placementId: "interstitial-320x480",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
      {
        name: "Square (Small Square)",
        width: 250,
        height: 250,
        category: "Social",
        placementId: "display-250x250",
        resizedUrl: "",
        creativeTemplateId: null,
        uniqueId: "",
      },
    ],
    selectedSizes: [],
    inputFile: null,
    inputPreview: null,
    inputUrl: "",
    deSelectedSizes: [],
    cameFromEditWithAI: false,
    isResizing: false,
    multiSizeTemplateId: null,
  }),
  actions: {
    // Toggle a size: add if not selected, remove if already selected
    toggleSize(size: Size) {
      const idx = this.selectedSizes.findIndex((s) => s.name === size.name);
      if (idx === -1) {
        this.selectedSizes.push(size);
      } else {
        this.selectedSizes.splice(idx, 1);
      }
    },

    // Remove a size from selectedSizes
    deselectSize(size: Size) {
      this.deSelectedSizes.push(size);
      this.selectedSizes = this.selectedSizes.filter(
        (s) => s.name !== size.name
      );
    },

    setSelectedSizes(sizes: Size[]) {
      this.selectedSizes = sizes;
    },

    // Add a user-defined custom size and select it.
    // Dedupes by dimensions against ALL existing sizes (regardless of
    // category) so a custom entry isn't created when a predefined size with
    // the same dimensions already exists. Returns the size if added/selected,
    // or null if it already exists in selectedSizes.
    addCustomSize(width: number, height: number, unit?: Size["unit"]): Size | null {
      const existing = this.sizes.find(
        (s) => s.width === width && s.height === height && s.unit === unit
      );

      const size: Size =
        existing ?? {
          name: `Custom ${width}x${height}`,
          width,
          height,
          unit,
          category: "Custom sizes",
          resizedUrl: "",
          creativeTemplateId: null,
          uniqueId: "",
        };

      if (!existing) {
        this.sizes.push(size);
      }

      const alreadySelected = this.selectedSizes.some(
        (s) => s.name === size.name
      );
      if (alreadySelected) return null;

      this.selectedSizes.push(size);
      return size;
    },

    setCreativeTemplateIdForSizeUrl(resizeUrl: string, templateId: number) {
      const currentSize = this.selectedSizes.find(
        (s) => s.resizedUrl == resizeUrl
      );
      if (currentSize) {
        currentSize.creativeTemplateId = templateId;
      }
    },
    setLiteTemplateIdForSizeUrl(resizeUrl: string, templateId: number) {
      const currentSize = this.selectedSizes.find(
        (s) => s.resizedUrl == resizeUrl
      );
      if (currentSize) {
        currentSize.liteTemplateId = templateId;
      }
    },
    setInputUrl(url: string) {
      this.inputUrl = url;
    },
    setInputPreview(url: string) {
      this.inputPreview = url;
    },
    setDeSelectedSizes(sizes: Size[]) {
      this.deSelectedSizes = sizes;
    },
    setCameFromEditWithAI(value: boolean) {
      this.cameFromEditWithAI = value;
    },
    setIsResizing(value: boolean) {
      this.isResizing = value;
    },
    setMultiSizeTemplateId(id: number | null) {
      this.multiSizeTemplateId = id;
    },
    clearSelectedSizeOutputs() {
      this.selectedSizes.forEach((size) => {
        size.resizedUrl = "";
        size.creativeTemplateId = null;
        size.liteTemplateId = null;
        size.uniqueId = "";
        size.outputWidth = undefined;
        size.outputHeight = undefined;
      });
      this.multiSizeTemplateId = null;
    },
    reset() {
      this.selectedSizes = [];
      this.sizes.forEach((size) => {
        size.resizedUrl = "";
        size.creativeTemplateId = null;
        size.liteTemplateId = null;
        size.uniqueId = "";
        size.outputWidth = undefined;
        size.outputHeight = undefined;
      });
      this.inputFile = null;
      this.inputPreview = null;
      this.inputUrl = "";
      this.deSelectedSizes = [];
      this.cameFromEditWithAI = false;
      this.isResizing = false;
      this.multiSizeTemplateId = null;
    },
  },
  getters: {
    // Automatically derive all categories from sizes
    categories: (state) => {
      const order = ["Social", "Display", "Custom sizes"];
      const present = new Set(state.sizes.map((s) => s.category));
      return order.filter((c) => present.has(c));
    },

    // Sizes grouped by category
    sizesByCategory: (state) => {
      const result: Record<string, Size[]> = {};
      state.sizes.forEach((s) => {
        if (!result[s.category]) result[s.category] = [];
        result[s.category].push(s);
      });
      return result;
    },

    //filter sizes by search string (global)
    filteredSizes: (state) => (search: string) => {
      if (!search) return state.sizes;
      const s = search.toLowerCase();
      return state.sizes.filter(
        (size) =>
          size.name.toLowerCase().includes(s) ||
          `${size.width}x${size.height}`.includes(s)
      );
    },
  },
});
